<template>
  <div class="check-LP"
       :class="[{disabled: disabled}, inlineClass]">
    <input :id="cbId"
           class=""
           type="checkbox"
           :disabled="disabled"
           v-model="model"/>
    <label :for="cbId" class="checkLabel">
      <slot>
        <span v-if="inline">&nbsp;</span>
      </slot>
    </label>
  </div>
</template>
<script>
import { randomString } from "./stringUtils";

export default {
  name: "base-checkbox",
  model: {
    prop: "checked"
  },
  props: {
    checked: {
      type: [Array, Boolean],
      description: "Whether checkbox is checked"
    },
    disabled: {
      type: Boolean,
      description: "Whether checkbox is disabled"
    },
    inline: {
      type: Boolean,
      description: "Whether checkbox is inline"
    }
  },
  data() {
    return {
      cbId: "",
      touched: false
    };
  },
  computed: {
    model: {
      get() {
        return this.checked;
      },
      set(check) {
        if (!this.touched) {
          this.touched = true;
        }
        this.$emit("input", check);
      }
    },
    /* eslint-disable */
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }
    }
  },
  mounted() {
    this.cbId = randomString()
  }
};
</script>
<style lang="scss">
.check-LP {
  display: flex;
  align-items: center;
  margin-top: 6px;
  .checkLabel {
    margin: 0px 6px 0 ;
    font-size: .875rem;
  }
}
</style>